import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a97b565")

_pushScopeId("data-v-5a97b565")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "qu-title" }, "编辑题目", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_option = _resolveComponent("a-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    class: "qu-wrap",
    visible: _ctx.visible,
    width: "800px"
  }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    footer: _withId(() => [
      _createVNode(_component_a_button, {
        class: "mr8",
        onClick: _ctx.handleCancel
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        type: 'primary',
        onClick: _ctx.handleOk
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withId(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withId(() => [
          _createVNode(_component_a_form_item, {
            label: "题型",
            wrapperCol: {span:8}
          }, {
            default: _withId(() => [
              _createVNode(_component_a_select, {
                value: _ctx.dataClone.questionType,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataClone.questionType = $event)),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleQTypeChange($event,_ctx.dataClone)))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.questionTypes, (q, qIndex) => {
                    return (_openBlock(), _createBlock(_component_a_option, { value: qIndex }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(q.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent(_ctx.dataClone.questionType)), { onEmitValidate: _ctx.handleEmitValidate }, null, 8, ["onEmitValidate"]))
    ]),
    _: 1
  }, 8, ["visible"]))
})